import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import {
  IconCircleCheck,
  IconEye,
  IconLayout,
  IconListDetails,
  IconPencilCode,
  IconSettings,
  IconSparkles,
  IconTags,
} from '@tabler/icons-react';
import { type IWidgetConfigurationSlot } from './IWidgetConfigurationSlot.ts';

/**
 * Preset degli slot (card) standard del Drawer di configurazione widget,
 * condivisi da campi e direttive (FWP-3685/FWP-2998).
 *
 * Le icone sono create una volta a livello di modulo, così l'identità dello
 * slot resta stabile tra i render dei fill che lo referenziano.
 */
export const WidgetConfigurationSlots = {
  General: {
    key: 'general',
    title: 'Impostazioni generali',
    icon: <TbIcon icon={IconSettings} />,
    description: 'Configurazione di base del campo.',
    order: 10,
  },
  Default: {
    key: 'default',
    title: 'Default e Compilazione',
    icon: <TbIcon icon={IconPencilCode} />,
    description: 'Valore iniziale e regole di compilazione.',
    order: 20,
  },
  Layout: {
    key: 'layout',
    title: 'Aspetto e Layout',
    icon: <TbIcon icon={IconLayout} />,
    description: 'Aspetto, dimensioni e disposizione del campo.',
    order: 25,
  },
  Semantic: {
    key: 'semantic',
    title: 'Semantica del dato',
    icon: <TbIcon icon={IconTags} />,
    description: 'Natura e significato del dato nel sistema.',
    order: 30,
  },
  Options: {
    key: 'options',
    title: 'Opzioni',
    icon: <TbIcon icon={IconListDetails} />,
    description: 'Elenco delle opzioni disponibili.',
    order: 40,
  },
  SpecialBehaviors: {
    key: 'special-behaviors',
    title: 'Comportamenti speciali',
    icon: <TbIcon icon={IconSparkles} />,
    description: 'Comportamenti particolari del campo in contesti specifici.',
    order: 50,
  },
  Validation: {
    key: 'validation',
    title: 'Regole di validazione',
    icon: <TbIcon icon={IconCircleCheck} />,
    description: 'Vincoli che il valore deve rispettare.',
    order: 60,
  },
  Display: {
    key: 'display',
    title: 'Regole di visualizzazione',
    icon: <TbIcon icon={IconEye} />,
    description: 'Condizioni di visibilità e abilitazione.',
    order: 70,
  },
} satisfies Record<string, IWidgetConfigurationSlot>;
